<template>
  <div>
    <Modal
      v-model="openForm"
      footer-hide
      width="700"
      @on-cancel="cliclCancelBtn"
    >
      <Tabs v-model="model">
        <TabPane label="绑定车辆" name="car">
          <ly-group>
            <ly-item
              v-for="(x, index) in dataList"
              :key="index"
              v-show="x.useType == '1'"
              >{{ x.name
              }}<Icon
                @click="dataList.splice(index, 1)"
                type="ios-backspace-outline"
            /></ly-item>
          </ly-group>
        </TabPane>
        <TabPane label="绑定人员" name="person">
          <ly-group>
            <ly-item
              v-for="(x, index) in dataList"
              :key="index"
              v-show="x.useType == '2'"
              >{{ x.name
              }}<Icon
                @click="dataList.splice(index, 1)"
                type="ios-backspace-outline"
            /></ly-item>
          </ly-group>
        </TabPane>
      </Tabs>

      <div class="clearfloat" style="widthL100%">
        <div style="float: left">
          <Button @click="add">新增</Button>
          <Button @click="dataList.splice(0, dataList.length)">清空</Button>
        </div>
        <div style="float: right">
          <Button type="primary" @click="save">提交保存</Button>
        </div>
      </div>
    </Modal>
    <Drawer
      title="请选择人员"
      placement="right"
      :closable="true"
      v-model="openPerson"
      draggable
      class="my-drawer"
      width="450"
    >
      <personTool
        v-if="openPerson"
        @persons="rePersons"
        :isMore="true"
      ></personTool>
    </Drawer>
    <Drawer
      title="请选择车辆"
      placement="right"
      :closable="true"
      v-model="openCar"
      draggable
      class="my-drawer"
      width="450"
    >
      <carTool v-if="openCar" @cars="reCars" :isMore="true"></carTool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["dataList123"],
  data() {
    return {
      openForm: false,
      openPerson: false,
      openCar: false,
      title: "",
      model: "car",
      dataList: [],
    };
  },
  methods: {
    open() {
      this.openForm = true;
    },
    add() {
      if (this.model == "car") {
        this.openCar = true;
      } else {
        this.openPerson = true;
      }
    },
    rePersons(v) {
      for (let i = 0; i < v.length; i++) {
        var obj = {
          name: v[i].userName,
          id: v[i].deviceId,
          key: v[i].deviceId,
          useType: "2",
        };
        this.dataList.unshift(obj);
      }

      this.dataList = this.utils.qcArr(this.dataList);
    },
    reCars(v) {
      for (let i = 0; i < v.length; i++) {
        var obj = {
          name: v[i].carNo,
          id: v[i].deviceId,
          key: v[i].deviceId,
          useType: "1",
        };
        this.dataList.unshift(obj);
      }

      setTimeout(() => {
        this.dataList = this.utils.qcArr(this.dataList);
      }, 0);
    },
    cliclCancelBtn() {},
    save() {
      this.$emit("blind", this.dataList);
      this.openForm = false;
    },
  },
  model: {
    prop: "dataList123",
    event: "aaa",
  },
  watch: {
    dataList123(v) {
      this.dataList = v;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/blind.vue